//@ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../api/axios';
import { BASE_URL } from '../constants/apiConstants';
import type { AxiosResponse } from '@types/axios';
interface MenuPlanType {
  daypartcode: string;
  daypartname: string;
}

interface MenuPlanState {
  menuPlantTypes: MenuPlanType[];
  loading: boolean;
  error: string | null;
}

const initialState: MenuPlanState = {
  menuPlantTypes: [],
  loading: false,
  error: null,
};


interface MenuPlanTypeResponse {
  data: {
    daypartdatalist: MenuPlanType[];
  };
}
interface FetchBridgerMenuPlanTypesPayload {
  userid: string | null;
  sitecode: string| null;
  useridvalue: string;
}

export const fetchBridgerMenuPlanTypes = createAsyncThunk<MenuPlanType[], FetchBridgerMenuPlanTypesPayload>(
  'menuBridgerPlan/fetchMenuBridgerPlanTypes',
  async (payload: FetchBridgerMenuPlanTypesPayload) => {
    const response: AxiosResponse<MenuPlanTypeResponse> = await axiosInstance.post(
      `${BASE_URL}/api/v1/Bridger/GetDayPartBySiteCode`,
      payload
    );   
    return response.data.data.daypartdatalist;
  }
);




const menuBridgerPlanSlice = createSlice({
  name: 'menuBridgerPlan',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBridgerMenuPlanTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBridgerMenuPlanTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.menuPlantTypes = action.payload;
      })
      .addCase(fetchBridgerMenuPlanTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch menu plan types';
      });
  },
});

export default menuBridgerPlanSlice.reducer;
